"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseToken = exports.getToken = void 0;

var _jwtDecode2 = _interopRequireDefault(require("jwt-decode"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var legacyKey = 'token';
var oktaKey = 'okta-token-storage';

var getToken = function getToken(options) {
  var search = new URL(window.location).searchParams;
  var searchToken = search.get('token');

  if (searchToken) {
    return searchToken;
  }

  if (options.tokenKey) {
    return JSON.parse(window.localStorage.getItem(options.tokenKey));
  }

  var oktaToken = JSON.parse(window.localStorage.getItem(oktaKey));

  if (oktaToken) {
    var accessToken = oktaToken.accessToken;
    return accessToken && accessToken.accessToken;
  }

  return JSON.parse(window.localStorage.getItem(legacyKey));
};

exports.getToken = getToken;
var envWhiteList = [new RegExp('^preprod$'), new RegExp('^production$'), new RegExp('^sandbox$'), new RegExp('^staging\\d{0,2}$')];

var determineEnv = function determineEnv(_ref) {
  var iss = _ref.iss,
      tokenEnv = _ref.tokenEnv;

  if (iss === 'production.guesty.com') {
    return 'production';
  }

  var env = tokenEnv || iss.split('.')[0];
  var isAllowed = false; // eslint-disable-next-line no-restricted-syntax

  var _iterator = _createForOfIteratorHelper(envWhiteList),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var regex = _step.value;
      var match = regex.exec(env);

      if (match) {
        isAllowed = true;
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return isAllowed ? env : null;
};

var parseToken = function parseToken(token) {
  try {
    var _jwtDecode = (0, _jwtDecode2["default"])(token),
        iss = _jwtDecode.iss,
        userRoles = _jwtDecode.userRoles,
        env = _jwtDecode.env;

    return {
      parsedEnv: determineEnv({
        iss: iss,
        tokenEnv: env
      }),
      userRoles: userRoles
    };
  } catch (e) {
    return {};
  }
};

exports.parseToken = parseToken;